import { Suspense, lazy } from 'react';

import { Spinner } from '@/common/components';
import { AppControllerType, AppRoutes } from '@/common/interfaces';

import { DynamicBaseBreadcrumb, DynamicSitesBreadcrumb } from '@/modules/AppBreadcrumb';

const RedirectsExternalListPage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsExternalList.page'));
const RedirectsExternalCreatePage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsExternalCreate.page'));
const RedirectsExternalEditPage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsExternalEdit.page'));
const RedirectsExternalPage = lazy(async () => await import('../../../pages/Sites/SitesRedirects/RedirectsExternal.page'));

export const ExternalRedirectsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.ExternalRedirects + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsExternalListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicExternalRedirectsListBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.ExternalRedirectsCreate,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsExternalCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 560
      }
    },
    {
      path: AppRoutes.ExternalRedirectsEdit,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsExternalEditPage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseEditBreadcrumb,
      props: {
        commonDrawerWidth: 560
      }
    },
    {
      path: AppRoutes.ExternalRedirectsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <RedirectsExternalPage/>
        </Suspense>
      ),
      breadcrumb: DynamicSitesBreadcrumb.DynamicExternalRedirectsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 500
      }
    }
  ]
};
